import { Github, GitMerge, GitPullRequest } from "lucide-react";
import { Button } from "../../../ui/button";

interface GitAccount {
  id: string;
  provider: string;
  username: string;
  avatarUrl?: string;
}

interface ProviderTabsProps {
  accounts: GitAccount[];
  activeId: string;
  onChange: (id: string) => void;
}

function ProviderIcon({ provider, className }: { provider: string; className?: string }) {
  if (provider === "github") return <Github className={className} />;
  if (provider === "bitbucket") return <GitPullRequest className={className} />;
  return <GitMerge className={className} />;
}

export function ProviderTabs({ accounts, activeId, onChange }: ProviderTabsProps) {
  return (
    <div className="flex gap-2 flex-wrap">
      {accounts.map((account) => (
        <Button
          key={account.id}
          variant={activeId === account.id ? "default" : "outline"}
          size="sm"
          className="gap-1.5 text-xs h-8"
          onClick={() => onChange(account.id)}
        >
          <ProviderIcon provider={account.provider} className="h-3.5 w-3.5" />
          {account.username}
        </Button>
      ))}
    </div>
  );
}
